export default "__VITE_PUBLIC_ASSET__97948234__"